import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取手机号
   * @param customerId 客户ID
   */
  getPhoneNumber(customerId) {
    return axios.get(`/api/v2/multi-poi-settle/pre-get-msg-code?customerId=${customerId}`);
  },
  /**
   * 获取验证码
   * @param customerId 客户ID
   */
  sendMsgCode(customerId) {
    return axios.get(`/api/v2/multi-poi-settle/get-msg-code?customerId=${customerId}`);
  },
  /**
   * 获取银行卡信息查看
   * @param customerId 客户ID
   * @param verificationCode 验证码
   */
  getBankAccount(customerId, verificationCode) {
    return axios.post('/api/v2/multi-poi-settle/get-bank-account', {
      customerId,
      verificationCode,
    });
  },
  /**
   * 查看银行卡明文
   * @param customerId 客户ID
   * @param bankAccountId 银行账号id
   */
  getBankCardNumber(customerId, bankAccountId) {
    return axios.post('/api/v2/multi-poi-settle/get-bank-card-number', {
      customerId,
      bankAccountId,
    });
  },
  /**
   * 商家确认银行卡-确认
   * @param customerId 客户ID
   * @param verificationCode 验证码
   * @param bankAccountId 客户中台银行账号ID
   */
  confirmBank(customerId, verificationCode, bankAccountId) {
    return axios.post('/api/v2/multi-poi-settle/confirm-bank', {
      customerId,
      verificationCode,
      bankAccountId,
    });
  },
};
